@if (!userWorkspaceService.mailAccounts.length) {
  <div class="flex h-full items-center justify-center">
    <p class="text-center">
      {{
        getMailAccountsError
          ? 'getMailAccountsError'
          : ('noMailAccountIsAvailableYet' | translate)
      }}
    </p>
  </div>
} @else {
  <div tourAnchor="mailAccounts">
    @if (userWorkspaceService.mailAccounts.length > 1) {
      <div class="flex items-center justify-between pl-[1.5rem] pr-[1rem]">
        <div class="ml-[auto]">
          <button
            (click)="changeOrder()"
            [disabled]="!orderBy"
            mat-icon-button
            matTooltip="{{ 'order' | translate }}">
            <mat-icon>{{
              orderDirection === orderDirectionEnum.Descending
                ? 'arrow_downward'
                : 'arrow_upwards'
            }}</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menuConnect">
            <mat-icon class="icon" [class.blue]="orderBy">sort</mat-icon>
          </button>
        </div>
      </div>
    }
    <mat-accordion>
      @for (
        mailAccount of userWorkspaceService.mailAccounts;
        track mailAccountTrackBy($index)
      ) {
        <mat-expansion-panel
          tourAnchor="mailAccount-{{ $index }}"
          hideToggle
          (afterExpand)="opened(this, mailAccount)"
          [expanded]="openMailAccountId === mailAccount.mailAccountId">
          <mat-expansion-panel-header
            class="account-name"
            (contextmenu)="onRightClick($event, mailAccount)">
            <mat-panel-title
              matTooltip="{{ getTitle(mailAccount) }}"
              class="mr-0 w-full justify-between">
              <span
                class="mr-[1rem] overflow-hidden text-ellipsis whitespace-nowrap">
                {{ getTitle(mailAccount) }}
              </span>
              <span
                tourAnchor="mailAccountBadge-{{ $index }}"
                class="default-theme-color text-end">
                {{ getBadge(mailAccount) }}
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          @if (isTreeLoaded) {
            <app-mail-account-folders
              #folders
              [mailAccountId]="mailAccount.mailAccountId"
              [isOpen]="openMailAccountId === mailAccount.mailAccountId"
              [tree]="getMailAccountTree(mailAccount.mailAccountId)"
              [folderCounts]="
                userWorkspaceService.folderCounts[mailAccount.mailAccountId] ||
                []
              "
              [infoOpenedMailAccount]="infoOpenedMailAccount"
              (updateDataSideNav)="updateDataSideNav()"
              (leftMenuOpen)="leftMenuOpen.emit()"></app-mail-account-folders>
          }
          <div class="flex flex-col gap-[0.5rem]">
            <div class="mt-[1rem] flex justify-between font-[500]">
              {{ 'spaceUsed' | translate }}
              <span class="space-text"> {{ mailAccount.spaceUsed }} GB</span>
            </div>
            @if (!!userWorkspaceService.mailAccountBadges.length) {
              <div class="flex flex-col gap-[0.25rem]">
                <div class="flex justify-between">
                  <div class="font-[500]">{{ 'connect' | translate }}</div>
                  <div
                    class="font-[500] {{
                      getColorText(mailAccount.mailAccountId)
                    }}">
                    {{
                      getConnectionStatusTitle(mailAccount.mailAccountId)
                        | translate
                    }}
                  </div>
                </div>
                @if (getConnectStatusInfo(mailAccount.mailAccountId)) {
                  <div
                    class="flex gap-[0.5rem] items-center {{
                      getColorText(mailAccount.mailAccountId)
                    }}">
                    <mat-icon>warning</mat-icon>
                    <div>
                      {{
                        getConnectStatusInfo(mailAccount.mailAccountId)
                          | translate
                      }}
                    </div>
                  </div>
                }
                @if (isConnectionStatusInfo(mailAccount.mailAccountId)) {
                  <div class="flex items-center gap-[0.5rem]">
                    <mat-icon class="text-red-600">warning</mat-icon>
                    <div class="text-red-600">
                      {{
                        getConnectionStatusInfo(mailAccount.mailAccountId)
                          | translate
                      }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
}

<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"></div>

<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <a mat-menu-item (click)="clickSettingMailAccount(item)">
      {{ 'settings' | translate }}
    </a>
  </ng-template>
</mat-menu>

<mat-menu #menuConnect (click)="$event.stopPropagation()">
  @for (state of ordersSortMenu; track state) {
    <button mat-menu-item (click)="setFilterChange(state)">
      <span [class.blue]="orderBy === state.id">{{
        state.title | translate
      }}</span>
    </button>
  }
</mat-menu>
